export default "/images/vendor/flag-icon-css/flags/1x1/fr.svg?c88df3297cffe49852ae43ae5d2dcdd4";